// @flow
import * as React from 'react'
import { Transition } from 'react-transition-group'
import Popper from '../Popper'
import { Arrow, Container } from './elements'

// Types
type Props = {
  placement?: string,
  content: any,
  target: any,
  wrapper?: any,
  color?: string,
  width?: any,
  showed?: boolean,
}

/**
 * CSS only tooltip implementation
 */
const Tooltip = ({
  target,
  placement,
  wrapper,
  content,
  color = 'white',
  width = 'auto',
  showed: tooltipShowed,
}: Props) => (
  <Popper
    showed={tooltipShowed}
    wrapper={wrapper}
    placement={placement}
    target={target}
    arrow={(innerRef, arrowProps, { placement: arrowPlacement }) => (
      <Arrow
        {...arrowProps}
        ref={innerRef}
        $placement={arrowPlacement}
        $color={color}
      />
    )}
    popper={(innerRef, popperProps, { roughPlacement, showed }) => (
      <Transition
        in={showed}
        timeout={{ enter: 1, exit: 650 }}
        mountOnEnter
        unmountOnExit
      >
        {(state) => (
          <Container
            {...popperProps}
            ref={innerRef}
            $placement={roughPlacement}
            $width={width}
            $color={color}
            $showed={state === 'entered'}
          >
            {popperProps.children}
            {React.isValidElement(content)
              ? content
              : React.createElement(content)}
          </Container>
        )}
      </Transition>
    )}
  />
)

export default Tooltip
